import { Button, Icon, Text } from "@simplybusiness/mobius";
import { list, grid2 } from "@simplybusiness/icons";
import classNames from "classnames/dedupe";
import { useSetLayoutToggleAtom } from "../../../../hooks/useSetLayoutToggleState";
import { useToggleLayoutPreference } from "../../../../hooks/useToggleLayoutPreference";
import { useAtom } from "jotai";
import { useSnowplowContext } from "@simplybusiness/services";
import { qcpLayoutToggleAtom } from "../../../../store";

export type Layout = "grid" | "list";

type LayoutToggleProps = {
  quotesLayoutPreference?: Layout;
};

export const LayoutToggle = ({ quotesLayoutPreference }: LayoutToggleProps) => {
  useSetLayoutToggleAtom(quotesLayoutPreference);
  const { toggleLayoutPreference } = useToggleLayoutPreference();
  const [layout, setLayout] = useAtom(qcpLayoutToggleAtom);
  const { snowplow } = useSnowplowContext();

  const handleClick = (newLayout: Layout) => {
    setLayout(newLayout);
    toggleLayoutPreference(newLayout);

    snowplow?.trigger("layoutToggleClickedExperiment", {
      layout: newLayout,
    });
  };

  return (
    <div className="mobius-layout-toggle">
      <Button
        variant="link"
        className={classNames("mobius-layout-toggle__item", {
          "mobius-layout-toggle__item--active": layout === "grid",
        })}
        onClick={() => handleClick("grid")}
      >
        <Text variant="small">Grid view</Text>
        <Icon icon={grid2} title="Switch to grid layout" />
      </Button>
      <div className="mobius-layout-toggle__divider" />
      <Button
        variant="link"
        className={classNames("mobius-layout-toggle__item", {
          "mobius-layout-toggle__item--active": layout === "list",
        })}
        onClick={() => handleClick("list")}
      >
        <Icon icon={list} title="Switch to list layout" />
        <Text variant="small">List view</Text>
      </Button>
    </div>
  );
};
